import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Link, Navigate, redirect } from "react-router-dom";
import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
// import Textarea from "@mui/joy/Textarea";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default class AddNotifications extends Component {
  state = {
    message: "",
    notification: false,
    redirect: false,
    image_url: {},
    title: "",
    notify_to: "all",
    testseries_id: "",
    testseries_name: "",
  };

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    this.setState({
      testseries_id: searchParams.get("testseries_id") || "",
      testseries_name: searchParams.get("testseries_name") || "",
    });
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData();

    if (this.state.notify_to === "testseries" && !this.state.testseries_id) {
      this.setState({
        notification: true,
        message: "Please open this screen from a test series to notify participated users.",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 3000);
      return;
    }

    fd.append("title", this.state.title);
    if (this.state.image_url) {
      fd.append("image_url", this.state.image_url);
    }
    fd.append("message", this.state.message);
    fd.append("notify_to", this.state.notify_to);
    if (this.state.notify_to === "testseries") {
      fd.append("testseries_id", this.state.testseries_id);
    }
    // fd.append("content", this.state.testimonial);
    // return;
    if (init() === "success") {
      axios
        .post(Constants.postUrls.createNewNotification, fd)
        .then((resp) => {
          // console.log(resp);
          this.setState({
            notification: true,
            message: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/notifications" />;
    } else {
      return (
        <div>
          <div>
            <DashboardLayout>
              <DashboardNavbar />
              <MDBox pt={6} pb={3}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Send Notification
                    </MDTypography>
                  </MDBox>
                  {/* <Grid item sm={4} px={2} align="right">
                    <Link to="/admin/addNewJob">
                      <MDButton variant="contained" size="small" color="primary">
                        Create Job
                      </MDButton>
                    </Link>
                  </Grid> */}
                  <MDBox py={3} px={2}>
                    <form onSubmit={this.handleSubmit}>
                      <Grid container sm={12} spacing={2}>
                        {this.state.testseries_name ? (
                          <Grid item sm={12}>
                            <TextField
                              type="text"
                              label="Selected Test Series"
                              value={this.state.testseries_name}
                              InputProps={{ readOnly: true }}
                              style={{ width: "100%", height: "100%" }}
                            />
                          </Grid>
                        ) : null}
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Title"
                            name="title"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Message"
                            name="message"
                            onChange={this.handleInput}
                            multiline
                            minRows={3}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>

                        <Grid item sm={6}>
                          <InputLabel>Select Notify To</InputLabel>
                          <Select
                            value={this.state.notify_to}
                            onChange={(e) => this.setState({ notify_to: e.target.value })}
                            name="notify_to"
                            label="Select Notify To"
                            // style={{
                            //   height: "45px",
                            // }}
                            required
                            style={{ width: "100%", height: "45px", color: "#111" }}
                          >
                            <MenuItem value="all">All Users</MenuItem>
                            <MenuItem value="testseries" disabled={!this.state.testseries_id}>
                              Participated Users
                            </MenuItem>
                          </Select>
                        </Grid>

                        <Grid item sm={6}>
                          <TextField
                            type="file"
                            label="Notification Image"
                            name="image_url"
                            focused
                            helperText="Optional. If added, this image will be used in the push notification and app notification list."
                            onChange={(e) => {
                              this.setState({
                                image_url: e.target.files[0],
                              });
                            }}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>

                        {/* <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Testimonial"
                            name="testimonial"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid> */}
                      </Grid>

                      <Grid align="left" mt={2}>
                        <MDButton variant="contained" size="small" color="info" type="submit">
                          {this.state.loading ? "Creating..." : "Create"}
                        </MDButton>
                      </Grid>
                    </form>
                  </MDBox>
                  <>
                    <MDSnackbar
                      color="success"
                      icon="notifications"
                      title="AgriQuiz"
                      content={this.state.message}
                      dateTime="Just now"
                      open={this.state.notification}
                      //   close={toggleSnackbar}
                    />
                  </>
                </Card>
              </MDBox>
            </DashboardLayout>
          </div>
        </div>
      );
    }
  }
}
